<template>
  <div>
    <v-layout column justify-center align-center class="mb-3 mt-3">
      <div class="body-2">{{planTitle}}</div>
    </v-layout>
    <table class="v-datatable v-table theme--light planTable">
      <tbody class="planBody">
        <tr v-for="limit in limitsText" :key="limit.value" :class="isMainTitle(limit)? 'titleRow' : ''">
          <td>
            <div class="planCol">
              <span v-html="formatHtml(limit.label)"></span>
            </div>
          </td>
          <td class="text-xs-center">
            <div class="planCol">
              {{limit.secondaryValue}}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  methods: {
    formatHtml(text) {
      // Replace /r/n with html br
      return text.replace(new RegExp('\\r?\\n', 'g'), '<br />')
    },
    isMainTitle(limit) {
      if (('' + limit.value).indexOf('.') === -1) {
        return true
      } else {
        return false
      }
    }
  },
  computed: {
    limitsText() {
      return this.$store.state.agency.quotation.queryInfo.limitsText
    }
  },
  props: {
    planTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.planTable {
  // Overwrite default height of 48px from material
  tbody td {
    height: 0px !important;
    vertical-align: top;
  }
  .planBody {
    .planCol {
      // Dont apply this on col, they (vuetify) has default padding for their col
      padding-top: 12px;
      padding-bottom: 12px;
    }
    tr.titleRow {
      background: #eee;
    }
  }
}
</style>
